import { Chip as MuiChip } from '@mui/material';
import React from 'react';

const Chip = ({ bgcolor, icon, labelColor, label, iconClasses }) => {
    return (
        <MuiChip
            sx={{
                backgroundColor: bgcolor,
                borderRadius: 2,
                px: 0.5,
                '& .MuiChip-label': {
                    fontSize: 10,
                    fontWeight: 600,
                    color: labelColor,
                    pl: 1,
                },
                '& .MuiChip-icon': {
                    ...iconClasses,
                },
            }}
            icon={icon}
            label={label}
            size='small'
        />
    );
};

export default Chip;
